import { type IconName, getIconByName } from "@repo/skapa";
import { type SVGProps } from "react";

const SCHEDULE_ICON_MAP: Record<string, IconName> = {
  WORK: "briefcase",
  REGULAR: "calendar",
  TRANSFER: "mobile-handover",
  PRESENCE: "person",
  MEETING: "chat",
  BREAK: "hot-drink",
  ABSENCE: "calendar-cancel",
};

export const getScheduleIcon = (
  shiftType?: string
): ((prefix?: string) => SVGProps<SVGElement>[]) | undefined => {
  if (!shiftType) {
    return undefined;
  }

  const iconName = SCHEDULE_ICON_MAP[shiftType.toUpperCase()];
  if (!iconName) {
    return undefined;
  }

  return getIconByName(iconName);
};
